import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { Button } from "components/Button";
import { isEmpty, isNil } from "lodash";
import { CSSProperties } from "react";

export const Tag = ({
    className,
    valueClassName,
    valueStyle,
    title,
    value,
    tooltip,
    preIcon = "plus-large",
    showPreIcon = true,
    posIcon = "xmark-large",
    onRemove,
    onAdd,
}: {
    className?: string;
    valueClassName?: string;
    valueStyle?: CSSProperties | undefined;
    title?: string;
    value?: string;
    tooltip?: string;
    preIcon?: IconProp;
    showPreIcon?: boolean;
    posIcon?: IconProp;
    onRemove?: () => void;
    onAdd?: () => void;
}) => {
    return (
        <div className={cn("d-flex", className)}>
            <Button
                title={tooltip}
                style={{
                    color: "var(--bs-table-color)",
                    borderColor: "var(--bg-active) !important",
                }}
                className={cn("py-1 px-2 bg-transparent border d-flex align-items-center justify-content-center", {
                    "rounded-end-0": onRemove !== undefined,
                })}
                onClick={onAdd}
            >
                {!isNil(preIcon) && showPreIcon && <FontAwesomeIcon className="visible pe-2" icon={preIcon} size="sm" />}
                {!isEmpty(title) && <strong>{title}:&nbsp;</strong>}
                {!isEmpty(value) && (
                    <span style={valueStyle} className={cn(valueClassName)}>
                        {value}
                    </span>
                )}
            </Button>

            {onRemove && (
                <Button
                    title={tooltip}
                    aria-label={tooltip || "Remove"}
                    style={{
                        color: "var(--bs-table-color)",
                        borderColor: "var(--bg-active) !important",
                    }}
                    className={cn(
                        "rounded-start-0 border-start-0 py-1 px-2 bg-transparent border d-flex align-items-center justify-content-center"
                    )}
                    onClick={onRemove}
                >
                    <FontAwesomeIcon className="visible" icon={posIcon} size="sm" />
                </Button>
            )}
        </div>
    );
};
